
import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/demon/room/init', method: 'GET', params }, { interceptResultCode: false });
};

// 购买魔法卷轴
export const buyAPI = (data) => {
  return axios({ url: '/demon/room/buy', method: 'POST', data }, { interceptResultCode: false });
};

// 刷新奖池
export const exchangeAPI = (data) => {
  return axios({ url: '/demon/room/exchange', method: 'POST', data }, { interceptResultCode: false });
};

// 加入保险箱
export const insureAPI = (data) => {
  return axios({ url: '/demon/room/insure', method: 'POST', data }, { interceptResultCode: false });
};

// 放出保险箱
export const insureOutAPI = (data) => {
  return axios({ url: '/demon/room/out', method: 'POST', data }, { interceptResultCode: false });
};

// 奖励领取
export const rewardAPI = (data) => {
  return axios({ url: '/demon/room/reward', method: 'POST', data }, { interceptResultCode: false });
};

// 查询直播间
export const findAPI = (data) => {
  return axios({ url: '/demon/room/find', method: 'POST', data }, { interceptResultCode: false });
};

// 帮助页面初始化数据(含授权)
export const onHelpGetInitDataAPI = (params) => {
  return axios({ url: '/demon/room/help', method: 'GET', params }, { interceptResultCode: false });
};

// 每日分享奖励
export const shareRewardAPI = (data) => {
  return axios({ url: '/demon/room/share', method: 'POST', data }, { interceptResultCode: false });
};

// 是否第一次进来
export const updateAPI = (data) => {
  return axios({ url: '/demon/room/update', method: 'POST', data }, { interceptResultCode: false });
};

// 领取任务积分
export const getTaskAPI = (data) => {
  return axios({ url: '/demon/room/get', method: 'POST', data }, { interceptResultCode: false });
};




// WEBPACK FOOTER //
// ./src/pages/servitor/bbj/api.js